import { createRpcBackend } from "@/backend/backendProvider";

export class OnboardingHandler {
  constructor(context) {
    this.backend = createRpcBackend(context);
  }

  async listPresets() {
    const res = await this.backend.onboardingCall("list_presets");
    return res.presets;
  }

  createSession({ presetId, sessionName, teamNames, iterationNames, artName }) {
    return this.backend.onboardingCall(
      "create_session",
      [],
      {
        preset_id: presetId,
        session_name: sessionName,
        team_names: teamNames,
        iteration_names: iterationNames,
        art_name: artName,
      },
      { throwing: true },
    );
  }
}
